import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { pluralReadableTypeName, readableTypeName } from '@iotv/core-services';
import { classDerivedDeviceEnabledTypes } from '@iotv/datamodel';
import { AdjacentType, getSimpleBranchingQuery, getSimpleSubjectQuery } from '@iotv/datamodel-core';
import { TabContext, TabPanel } from '@mui/lab';
import { Box, Tab, Tabs } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ConsumerDao } from '../../data/ConsumerDAO';
import { isAdminRole } from '../../helpers/access';
import { useMostProximateCustomer } from '../../hooks/useMostProximateCustomer';
import { useTabHandlerStringKeys } from '../../hooks/useTabHandler';
import { ShowDefinedEntriesOnlyOpts } from '../../types/AppTypes';
import { CustomerDetailCard } from '../../v2/components/generic/ObjectView/DetailCard/CustomerDetailCard';
import { ObjectHeader } from '../../v2/components/generic/ObjectView/ObjectHeader';
import { getViewDefintionFromObject } from '../factories/AttributeDefinitions';
import { AutoTab } from '../PropertyArea';
const debug = process.env.REACT_APP_DEBUG && false;
export const CustomerView = ({ viewObject, contextCustomer, userSelectedGroup, applicationData, userFunctions, transactionFunctions, allowedActions, }) => {
    const contextObject = viewObject.matchedPrimary;
    const isAdmin = isAdminRole(userSelectedGroup);
    const mostProximateCustomer = useMostProximateCustomer({ item: contextObject });
    const [canDelete, setCanDelete] = useState(contextObject?.id !== contextCustomer?.id);
    useEffect(() => {
        setCanDelete(contextObject?.id !== contextCustomer?.id);
    }, [contextObject, contextCustomer]);
    const retrieveCustomerContext = (cust) => {
        const customerContextQuery = getSimpleSubjectQuery('Customer');
        customerContextQuery.addSubQuery(getSimpleBranchingQuery('Customer', 'Group', AdjacentType.CHILD));
        customerContextQuery.addSubQuery(getSimpleBranchingQuery('Customer', 'Team', AdjacentType.CHILD));
        customerContextQuery.addSubQuery(getSimpleBranchingQuery('Customer', 'Property', AdjacentType.CHILD));
        ConsumerDao.getGraphQueryRequestV2({ contextObjects: [cust], query: customerContextQuery }).then((cust_ctx_res) => {
            debug && console.log(cust_ctx_res);
            if (cust_ctx_res.data) {
                userFunctions.addObjectsToState(cust_ctx_res.data.getContainedNodesAndEdges());
            }
        });
    };
    useEffect(() => {
        if (contextObject)
            retrieveCustomerContext(contextObject);
    }, [contextObject?.sk]);
    const tabs = [
        {
            label: 'Details',
            value: 'Details',
            component: contextObject && applicationData ? (_jsx(CustomerDetailCard, { mostProximateCustomer: mostProximateCustomer, matchedPrimary: contextObject, transactionFunctions: transactionFunctions, definedEntriesOnlyOpt: ShowDefinedEntriesOnlyOpts.Yes, allowedActions: allowedActions, userFunctions: userFunctions, viewDefinition: getViewDefintionFromObject(contextObject) })) : (_jsx(_Fragment, {})),
        },
        {
            label: 'Customer Groups',
            value: 'Customer',
            direction: AdjacentType.CHILD,
            type: 'Group',
            constraints: [{ key: 'supportedType', value: 'Customer' }],
            adminOnly: true,
        },
        { label: 'User Groups', value: 'User', type: 'Group', constraints: [{ key: 'supportedType', value: 'User' }], adminOnly: true },
        { label: 'People', value: 'Person', type: 'Person' },
        { label: 'Teams', value: 'Team', type: 'Team' },
        { label: 'Gateway Groups', value: 'Gateway', type: 'Group', constraints: [{ key: 'supportedType', value: 'Gateway' }] },
        { label: 'Device Groups', value: 'Device', type: 'Group', constraints: [{ key: 'supportedType', value: 'Device' }] },
        { label: 'Properties', value: 'Property', type: 'Property' },
        ...classDerivedDeviceEnabledTypes.map((k) => ({
            label: `${readableTypeName(k)} ${pluralReadableTypeName('Group')}`,
            value: `${k}`,
            type: 'Group',
            constraints: [{ key: 'supportedType', value: k }],
        })),
    ].filter((t) => (isAdmin ? true : t.adminOnly !== true));
    const tabKeyMap = Object.fromEntries(tabs.map((t) => [t.value, t]));
    const { state: [[value, setValue]], handlers: { handleTabChange }, } = useTabHandlerStringKeys(tabKeyMap);
    return contextObject ? (_jsxs(_Fragment, { children: [_jsx(ObjectHeader, { vob: contextObject }), _jsxs(TabContext, { value: value, children: [_jsx(Box, { sx: { width: '100%', overflowX: 'auto' }, children: _jsx(Tabs, { value: value, onChange: handleTabChange, children: tabs.map((t) => (_jsx(Tab, { label: t.label, value: t.value, sx: { textTransform: 'none' } }, t.value))) }) }), tabs.map((t) => {
                        return (_jsx(TabPanel, { value: t.value, sx: { padding: 0, paddingBlockStart: 1 }, children: _jsx(AutoTab, { tabDef: t, viewObject: viewObject, contextObject: contextObject, contextCustomer: contextCustomer, mostProximateCustomer: mostProximateCustomer, userFunctions: userFunctions, transactionFunctions: transactionFunctions }) }, `${t.value}_tabPanel`));
                    })] }, 'CustomerViewBoxTabContext')] })) : (_jsx(_Fragment, {}));
};
